export const APPSFLYER_EVENT_NAME = {
  USER_LOGIN: 'User Login',
  USER_REGISTER: 'User Register',
  USER_SUBSCRIBE: 'User Subscribe',
  USER_OPT_IN: 'User Opt In',
} as const;

export type AppsFlyerEventName =
  (typeof APPSFLYER_EVENT_NAME)[keyof typeof APPSFLYER_EVENT_NAME];
